module.exports = __webpack_public_path__ + "assets/img/2.b4ef36eb.png";